import { render, staticRenderFns } from "./UpdateAccountDetails.vue?vue&type=template&id=ff48cd8e&scoped=true"
import script from "./UpdateAccountDetails.vue?vue&type=script&lang=js"
export * from "./UpdateAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff48cd8e",
  null
  
)

export default component.exports